import React from 'react';
import './TeachingCard.module.scss';
import { motion } from 'framer-motion';
import Button from 'components/UI/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export default function TeachingCard(props) {
    const history = useHistory();
    return (
        <motion.div
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            onClick={() => props.onClick()}
            styleName={`teaching-card ${props?.active ? 'active' : ''} `}
        >
            <div styleName="image-wrapper ">
                <img alt="teacher" src={props?.content?.image} />
            </div>
            <p styleName="title">{props?.content?.title}</p>
            <p styleName="description">{props?.content?.description}</p>
            <div styleName="button-wrapper">
                <Button
                    color={props?.active ? 'blue' : 'blue-gray'}
                    onClick={() =>
                        history.push(
                            `/test/extra-informatie-popup/${props?.content?.answerLabel}`
                        )
                    }
                >
                    Meer informatie <FontAwesomeIcon icon={faInfoCircle} />
                </Button>
            </div>
        </motion.div>
    );
}
